import {customElement} from 'lit/decorators.js';
import {html, LitElement} from "lit";
import {style} from "./tag-list.styles"

@customElement('sbk-tag-list')
export class SbkTagList extends LitElement {

    static get styles() {
        return style;
    }

    render() {
        return (html`
            <div class="tag-list__wrapper">
                <slot></slot>
            </div>
        `);
    }
}
